import { forwardRef } from 'react';
import type { ButtonProps } from './Button';
import { Button } from './Button';

/**
 * IconButton component - shortcut wrapper around Button with isIconOnly=true
 * Provides all functionality of Button while ensuring it's always icon-only
 */
export type IconButtonProps = Omit<ButtonProps, 'isIconOnly' | 'children'> & {
  'aria-label': string; // Required for accessibility
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { 'aria-label': ariaLabel, ...rest } = props;

    return <Button ref={ref} isIconOnly aria-label={ariaLabel} {...rest} />;
  }
);

IconButton.displayName = 'IconButton';

export { IconButton };
